module.exports = "/virtual-football-league/img/video/clubs/england/m-united.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/england/m-united.png
// module id = 337
// module chunks = 4